export default {
  enabled: true,
  hjid: 1338118,
  hjsv: 6,
};
